import { DetailItem } from '@qlibs/react-components';
import { Alert, Row, Col, Divider } from 'antd';
import moment from 'moment';
import SectionContent from '../../../components/SectionContent';
import styled from 'styled-components';

type IProps = {
  data: any;
};

const DeviceDetailInformation: React.FC<IProps> = ({ data }) => {
  return (
    <ContainerDetail>
      {data?.deletedAt ? (
        <Alert
          className='mb-5'
          type='warning'
          message='This data has been archived and cannot be edited'
        />
      ) : (
        false
      )}
      <SectionContent
        groupTitle='Information'
        subTitle='General information about this device'
      >
        <Row>
          <Col span={12}>
            <DetailItem label='Name' value={data.name} />
          </Col>
          <Col span={12}>
            <DetailItem
              label='Device Type'
              value={data.deviceType.name || 'N/A'}
            />
          </Col>
          <Col span={12}>
            <DetailItem label='Unique ID' value={data.uniqueId || 'N/A'} />
          </Col>
          <Col span={12}>
            <DetailItem
              label='Created by'
              value={data?.userCreator?.name || 'N/A'}
            />
          </Col>
          <Col span={12}>
            <DetailItem
              label='Created at'
              value={moment(data.createdAt).format('DD MMMM YYYY, HH:mm')}
              // type="datetime"
            />
          </Col>
          <Col span={12}>
            <DetailItem
              label='Updated at'
              value={moment(data.updatedAt).format('DD MMMM YYYY, HH:mm')}
              // type="datetime"
            />
          </Col>
          {data.metadata && data.metadata.aeFuelConstanta && (
            <Col span={12}>
              <DetailItem
                label='AE Fuel Constanta'
                value={data.metadata.aeFuelConstanta + ' L/Min'}
              />
            </Col>
          )}
          <Col span={12}>
            <DetailItem
              label='Status'
              value={data.status.toUpperCase()}
              type='tag'
              _tagProps={{
                color: data.status === 'active' ? 'success' : 'error',
              }}
            />
          </Col>
        </Row>
      </SectionContent>

      <Divider />

      <SectionContent
        groupTitle='Asset'
        subTitle='List of companies that include in this device'
      >
        <Row>
          <Col span={12}>
            <DetailItem label='Name' value={data?.asset?.name} />
          </Col>
          <Col span={12}>
            <DetailItem
              label='Company'
              value={data?.asset?.company?.name || 'N/A'}
            />
          </Col>
          <Col span={12}>
            <DetailItem
              label='PIC Name'
              value={data?.asset?.picName || 'N/A'}
            />
          </Col>
          <Col span={12}>
            <DetailItem
              label='PIC Phone Number'
              value={data?.asset?.picPhoneNumber || 'N/A'}
            />
          </Col>
        </Row>
      </SectionContent>
    </ContainerDetail>
  );
};

export const ContainerDetail = styled.div`
  margin-top: 10px;
`;

export default DeviceDetailInformation;
